import React, { useState } from 'react';
import Header from "../../common/header";
import WithSubmit from "../../common/WithSubmit";
import remoteFiles from "../../../../common/remote_files";
import SelectInText from "../../common/details/SelectInText";
import CheckBox from "../../common/details/CheckBox";
import BuzzbackProjectives from "../../common/details/BuzzbackProjectives";
import HiddenFields from "./HiddenFields";
import Descriptor from "./Descriptor";

const App = ({ data, options, errors }) => {
  const [ model, setModel ] = useState({
    tbEnabled: data.tb_enabled,
    cfEnabled: data.cf_enabled,
    diagnosticsNum: data.diagnostics_num,
    surveyDescriptor: data.survey_descriptor,
    surveyDescriptorSettings: data.survey_descriptor_settings,
    brandName: data.brand_name
  });

  const [ tbQuestion ] = useState(() => (
    options.thought_bubble_question.replace(/%currentFlavor%/, '[item]')
  ));

  return (
    <WithSubmit
      formId="details_form"
      errors={ errors }
      options={ options }
    >
      <HiddenFields
        options={ options }
        model={ model }
      />
      <div className="content -relative -grey-background">
        <Header title={ options.project_title } />
        <div className="content_body">
          <div className="form">

            <Descriptor
              model={ model }
              setModel={ setModel }
              descriptorOptions={ options.descriptor_options }
              errors={ errors }
              options={ options }
            />

            <div className="form_section -sm-space -padding-bottom">
              <div className="form_group -relative">
                <BuzzbackProjectives namesText="items" />

                <SelectInText
                  initValue={ model.diagnosticsNum }
                  onChange={ (v) => { setModel({ ...model, diagnosticsNum: v }); } }
                  options={ options.diagnostics_options }
                  namesText="items"
                  nameText="item"
                />

                <div className="form_metrics -md">
                  <CheckBox
                    initValue={ model.cfEnabled }
                    onChange={ (v) => { setModel({ ...model, cfEnabled: v }); } }
                    inputId="id-cf"
                    text="Concept Focus"
                    infoText={
                      <>
                        With Concept Focus, respondents markup elements of the item
                        {' '}
                        that resonate and explain why.
                      </>
                    }
                    img={ remoteFiles.express.steps.flavor.conceptFocus }
                  />
                  <CheckBox
                    initValue={ model.tbEnabled }
                    onChange={ (v) => { setModel({ ...model, tbEnabled: v }); } }
                    className="-border-bottom"
                    inputId="id-tb"
                    text="Thought Bubble"
                    infoText={
                      <>
                        With Thought Bubble, respondents will dissociate and provide words
                        {' '}
                        to describe the item. Sample question text:
                        {' '}
                        "{tbQuestion}"
                      </>
                    }
                    img={ remoteFiles.express.steps.flavor.thoughtBubble }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WithSubmit>
  );
};

export default App;
